/* Header count badges on the wishlist and cart icons.

   The badges are drawn by header.css from a data attribute on each link, so this
   file only has to keep those attributes (and the links' accessible names) true.

   Cart: cart-drawer.js already rewrites a[data-cart-count] after every add,
   quantity change and removal, and Liquid renders the first value. All this does
   is mirror that number into the aria-label, and re-read the cart when the page
   comes back from the back/forward cache with a stale count.

   Wishlist: localStorage is the wishlist's source of truth (see wishlist.js), but
   wishlist.js only loads on pages that show hearts. The header is on every page,
   so it reads the same key itself and follows wishlist.js's change event (this
   tab) and the storage event (other tabs). */

(() => {
  if (window.CaratKinHeaderCounts) return;
  window.CaratKinHeaderCounts = true;

  const WISHLIST_KEY = "carat_kin_wishlist";
  const root = () => window.Shopify?.routes?.root || "/";

  const itemsLabel = (base, n) => (n > 0 ? `${base}, ${n} item${n === 1 ? "" : "s"}` : base);

  function wishlistCount() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(WISHLIST_KEY) || "[]");
      return Array.isArray(parsed) ? parsed.length : 0;
    } catch {
      // Private browsing and full storage both throw; show no badge.
      return 0;
    }
  }

  function paintWishlist(count) {
    const n = typeof count === "number" ? count : wishlistCount();
    document.querySelectorAll("[data-wishlist-link]").forEach((link) => {
      link.dataset.wishlistCount = String(n);
      link.setAttribute("aria-label", itemsLabel("Wishlist", n));
    });
  }

  function paintCartLabel(link) {
    link.setAttribute("aria-label", itemsLabel("Shopping cart", Number(link.dataset.cartCount || 0)));
  }

  function setCartCount(n) {
    document.querySelectorAll("a[data-cart-count]").forEach((link) => {
      link.dataset.cartCount = String(n);
    });
  }

  // Wishlist
  paintWishlist();
  document.addEventListener("carat-kin:wishlist-change", (event) => {
    const ids = event.detail?.ids;
    paintWishlist(Array.isArray(ids) ? ids.length : undefined);
  });
  window.addEventListener("storage", (event) => {
    if (event.key === WISHLIST_KEY) paintWishlist();
  });

  // Cart: keep the accessible name in step with whatever cart-drawer.js writes.
  const cartLinks = document.querySelectorAll("a[data-cart-count]");
  cartLinks.forEach(paintCartLabel);
  const observer = new MutationObserver((records) => records.forEach((r) => paintCartLabel(r.target)));
  cartLinks.forEach((link) => observer.observe(link, { attributes: true, attributeFilter: ["data-cart-count"] }));

  // A page restored from the back/forward cache keeps its old HTML, so both
  // counts can be stale (e.g. items added on the page the customer came back from).
  window.addEventListener("pageshow", (event) => {
    if (!event.persisted) return;
    paintWishlist();
    fetch(`${root()}cart.js`, { headers: { Accept: "application/json" } })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (cart && typeof cart.item_count === "number") setCartCount(cart.item_count);
      })
      .catch(() => {});
  });
})();
